import React from 'react';
import styles from './Social.module.css';
import { FaWhatsapp, FaInstagram, FaFacebookF, FaPhone } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';

const SocialLinks = () => {
  const message = encodeURIComponent('היי חינת הזהב, הגעתי מהדף שלכם! אשמח לשמוע עוד על..');
  const phone = '972507277178';

  const socialLinks = [
    {
      name: 'WhatsApp',
      icon: <FaWhatsapp />,
      url: `https://wa.me/${phone}?text=${message}`,
      label: 'שלחי הודעה בוואטסאפ'
    },
    {
      name: 'Phone',
      icon: <FaPhone />,
      url: `tel:+${phone}`,
      label: 'התקשרי עכשיו'
    },
    {
      name: 'Instagram',
      icon: <FaInstagram />,
      url: 'https://www.instagram.com/hinatazav/',
      label: 'עקבי באינסטגרם'
    },
    {
      name: 'TikTok',
      icon: <SiTiktok />,
      url: 'https://www.tiktok.com/@henatazav',
      label: 'עקבי בטיקטוק'
    },
    {
      name: 'Facebook',
      icon: <FaFacebookF />,
      url: 'https://www.facebook.com/henatazav',
      label: 'עקבי בפייסבוק'
    }
  ];

  return (
    <div className={styles.socialContainer}>
      <div className={styles.socialGrid}>
        {socialLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
            aria-label={link.label}
          >
            <div className={styles.iconWrapper}>
              {link.icon}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialLinks;